/**
 *
 *  @constructor AvvioCustomMap
 *  
 *  @param {}
 *  
 *  @description Creates new AvvioCustomMap instance
 *
 */
var AvvioCustomMap = function(options) {

  /* GLOBAL OPTIONS */
  this.options = options || {};
  //console.log('%cMap Options', 'color: blue', options);
  this.clusterMap = document.querySelector('.js-avvio-custom-map-container'); // get the map directory

  // DOM elements
  this.options.mainSection = options.hasOwnProperty('mainSection') ? options.mainSection : null; // main map section
  this.options.mapFilters = options.hasOwnProperty('mapFilters') ? options.mapFilters : null; // map filter wrapper;
  this.options.mapContainer = options.hasOwnProperty('mapContainer') ? options.mapContainer : null; // map container;

  this.options.mapData = options.hasOwnProperty('mapData') ? options.mapData : null; // get map data

  // Map reference
  this.options.map = null;
  this.options.mapInfoWindow = null;
  this.options.mapMainMarker = null;
  this.options.currentmarkers;
  this.options.allMarkers = [];

  this.AvvioCustomMap = new Object();

  this.init();

}


/**
 *
 *  @function init
 *  
 *  @param {}
 *  
 *  @description Initiates child methods and handlers
 *
 */
AvvioCustomMap.prototype.init = function() {
  //console.log('%c[ Avvio Custom Map init ]', 'background-color: #112856; color: #c39775; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

  let _self = this;

  // check if main section exists and map data exists. Proceed further only if these are true else stop further execution
  if( _self.options.mapData != null && (typeof(_self.options.mainSection) != 'undefined' && _self.options.mainSection != null) ) {

    // check if the map is a static map
    if ( !_self.options.mainSection.classList.contains('avvio-custom-map--is-static') ) {

      // initiaize the map
      _self.initMap();

    }
    else {
      //console.log('%c[ Avvio Custom Map can not be initialized for being a static map ]', 'background-color: #a53112; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');
      return;
    }

  }
  else {
    //console.log('%c[ Avvio Custom Map can not be initialized due to invalid data/DOM or being a static map ]', 'background-color: #a53112; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');
    return;
  }
}


/**
 *
 *  @function initMap
 *  
 *  @param {}
 *  
 *  @description Initiates The Custom Map
 *
 */
AvvioCustomMap.prototype.initMap = function() {
  //console.log('%c[ Avvio Custom Map init method ]', 'background-color: #19a105; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

  let _self = this;

  // create the map
  _self.options.map = new google.maps.Map(_self.options.mapContainer, {
    center: new google.maps.LatLng(_self.options.mapData.mainMap.lat, _self.options.mapData.mainMap.long),
    zoom: _self.options.mapData.settings.zoom,
    styles: _self.options.mapData.settings.styled ? _self.options.mapData.settings.styles : _self.options.mapData.settings.styles
  });

  // Add custom controls
  const centerControlDiv = document.createElement("div");
  _self.centerControl(centerControlDiv, _self.options.map);
  _self.options.map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);

  // create info window
  _self.createInfoWindow();

  // add marker if present
  if( _self.options.mapData.icon != '' || _self.options.mapData.icon != null ) {

    //console.log('%c[ Place Main Marker ]', 'background-color: #333; color: #f38c0c; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

    _self.options.mapMainMarker =  new google.maps.Marker({
      position: new google.maps.LatLng(_self.options.mapData.mainMap.lat, _self.options.mapData.mainMap.long),
      icon: _self.options.mapData.mainMap.icon,
      title: _self.options.mapData.mainMap.title ? _self.options.mapData.mainMap.title : '',
      animation: _self.options.mapData.settings.markerAnimation ? _self.options.mapData.settings.markerAnimationType == 'DROP' ? google.maps.Animation.DROP : google.maps.Animation.BOUNCE : false,
      map: _self.options.map
    });

    // Add a click listener for the marker, and set up the info window. If infowindow is true in global setting
    if( _self.options.mapData.settings.enableInfoWindow == true ) {

      _self.options.mapMainMarker.addListener("click", () => {
        _self.options.mapInfoWindow.close();
        _self.options.mapInfoWindow.setContent(`<div class="marker">
                            <div class="marker-card">
                                ${ _self.options.mapData.mainMap.info_image ? `<div class="marker-card__thumbnail" style="background-image: url(${ _self.options.mapData.mainMap.info_image.sizes.large })">` : '' }
                                </div>
                                <div class="marker-card__content">
                                    ${ _self.options.mapData.mainMap.title ? `<h3 class="marker-card__title">${ _self.options.mapData.mainMap.title }</h3>` : '' }
                                    ${ _self.options.mapData.mainMap.desc ? `<strong class="marker-card__location">${ _self.options.mapData.mainMap.desc } <i class="fas fa-map-marker-alt"></i></strong>` : '' }
                                    ${ _self.options.mapData.mainMap.cta_link ? `<a class="marker-card__link" href="${ _self.options.mapData.mainMap.cta_link.url }" target="${ _self.options.mapData.mainMap.cta_link.target }">${ _self.options.mapData.mainMap.cta_link.title }</a>` : '' }
                                </div>
                            </div>
                        </div>`);
        _self.options.mapInfoWindow.open(_self.options.mapMainMarker.getMap(), _self.options.mapMainMarker);
      });

    }

  }

  // Create Filters
  _self.creatFilters();

  // Create Markers
  _self.createMarkers();

  // Center map based on markers.
  _self.centerMap( _self.options.map );

}


/**
 *
 *  @function centerControl
 *  
 *  @param {}
 *
 */
AvvioCustomMap.prototype.centerControl = function(controlDiv, map) {
  let _self = this;

  // Set CSS for the control border.
  const controlUI = document.createElement("div");

  controlUI.style.backgroundColor = "#fff";
  controlUI.style.border = "2px solid #fff";
  controlUI.style.borderRadius = "3px";
  controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
  controlUI.style.cursor = "pointer";
  controlUI.style.marginTop = "8px";
  controlUI.style.marginBottom = "22px";
  controlUI.style.textAlign = "center";
  controlUI.title = "Click to recenter the map";
  controlDiv.appendChild(controlUI);

  // Set CSS for the control interior.
  const controlText = document.createElement("div");

  controlText.style.color = "rgb(25,25,25)";
  controlText.style.fontFamily = "Roboto,Arial,sans-serif";
  controlText.style.fontSize = "16px";
  controlText.style.lineHeight = "38px";
  controlText.style.paddingLeft = "5px";
  controlText.style.paddingRight = "5px";
  controlText.innerHTML = "Center Map";
  controlUI.appendChild(controlText);
  // Setup the click event listeners: simply set the map to Chicago.
  controlUI.addEventListener("click", () => {
    console.log(_self.options.currentMarkers);
      _self.centerMap(map,_self.options.currentMarkers);
  });

}


/**
 *
 *  @function centerMap
 *  
 *  @param {}
 *
 */
AvvioCustomMap.prototype.centerMap = function(map,filteredMarkers) {
  //console.log('%c[ Creating Avvio Custom Map InfoWindow ]', 'background-color: #435611; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

  let _self = this;

  var markers = _self.options.allMarkers;
  _self.options.currentMarkers = markers;
  // Create map boundaries from all map markers.
  var bounds = new google.maps.LatLngBounds();
  markers.forEach(function( marker ){
      bounds.extend({
          lat: marker.position.lat(),
          lng: marker.position.lng()
      });
  });

  // Case: Single marker.
  if( markers.length == 1 ){
      map.setCenter( bounds.getCenter() );
  // Case: Multiple markers.
  } else if(markers.length > 1) {
      map.fitBounds( bounds );
  }
  // Default when no markers
  else {
      map.setCenter(_self.options.mapData.mainMap.long, _self.options.mapData.mainMap.lat,7);
  }

}


/**
 *
 *  @function createInfoWindow
 *  
 *  @param {}
 *  
 *  @description Creates Map Info window
 *
 */
AvvioCustomMap.prototype.createInfoWindow = function() {
  //console.log('%c[ Creating Avvio Custom Map InfoWindow ]', 'background-color: #435611; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

  let _self = this;

  // Create Map InfoWindow if enabled
  if( _self.options.mapData.settings.enableInfoWindow == true )
    _self.options.mapInfoWindow = new google.maps.InfoWindow({maxWidth: 300});

}


/**
 *
 *  @function creatFilters
 *  
 *  @param {}
 *  
 *  @description Creates Map Filters
 *
 */
AvvioCustomMap.prototype.creatFilters = function() {
  //console.log('%c[ Creating Avvio Custom Map Filters ]', 'background-color: #41004e; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

  let _self = this;

  // get filters DOM element
  const filterList = _self.options.mapFilters.querySelector('.avvio-custom-map__filter-list');

  // loop hrough filters object
  for (let item in _self.options.mapData.filters) {

    // check if markars array is present, if not create it
    _self.options.mapData.filters[item].markers = [];

    let data = _self.options.mapData.filters[item];

    filterList.append(_self.createFilterLabel(data.name, data.filterIcon, data.markerIcon));

  }


  // attach filter handler
  _self.handleFilters(filterList);

}


/**
 *
 *  @function createFilterLabel
 *  
 *  @param {name, filterIcon, markerIcon}
 *  
 *  @description Creates Filter Items and Returns the template
 *
 */
AvvioCustomMap.prototype.createFilterLabel = function(name, filterIcon, markerIcon) {
  //console.log('%c[ Creating Filter Label for:  ' + name + ' ]', 'background-color: #08037a; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

  let _self = this;

  const filterItemTemplate = `<label class="avvio-custom-map__filter-item" for="avvio_map_${ name }" tabindex="0">
                                <input type="checkbox" name="avvio_map_${ name }" id="avvio_map_${ name }" data-filter-type="${ name }" class="avvio-custom-map__checkbox" checked aria-labelledby="avvio_map_${ name }" tabindex="0">
                                <div class="avvio-custom-map__filter-checkbox">
                                  <span class="avvio-custom-map__filter-checkbox__indicator"></span>
                                </div>
                                <div class="avvio-custom-map__filter-label">
                                  <span class="avvio-custom-map__filter-icon">
                                  </span>
                                  <span class="avvio-custom-map__filter-text">
                                    ${ name }
                                  </span>
                                </div>
                              </label>`;

  const filterItem = document.createElement('li');
  filterItem.classList.add('js-map-markers');
  filterItem.innerHTML = filterItemTemplate;
  
  // convert svg image to svg xml code
  let filterIconElem = filterItem.querySelector('.avvio-custom-map__filter-icon');
  _self.convertSVGImageToXML(filterIconElem, filterIcon);

  return filterItem;
}


/**
 *
 *  @function convertSVGImageToXML
 *  
 *  @param {imagePath}
 *  
 *  @description Converts SVG Image to XML
 *
 */
AvvioCustomMap.prototype.convertSVGImageToXML = function(svgImageParent, svgImagePath) {
  //console.log('%c[ Converting SVG Image ' + svgImagePath +' to XML ]', 'background-color: #00544f; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

  // fetch and convert to svg code
  fetch(svgImagePath).then((res) => res.text()).then((data) => {
    const parser = new DOMParser();
    const svg = parser
      .parseFromString(data, "image/svg+xml")
      .querySelector("svg");

    svgImageParent.appendChild(svg);
  })
  //.then(return svg)
  .catch((error) => console.error(error));

}


/**
 *
 *  @function handleFilters
 *  
 *  @param {}
 *  
 *  @description Handles map filter interactions
 *
 */
AvvioCustomMap.prototype.handleFilters = function(listEl) {
  //console.log('%c[ Attaching Avvio Custom Map Filter Handler ]', 'background-color: #9b3804; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

  let _self = this;

  // get filter trigger
  listEl.previousElementSibling.addEventListener('click', function(e){
    this.classList.toggle('is-active');
  });

  let checkboxes = listEl.querySelectorAll('input[type="checkbox"]');

  listEl.querySelectorAll('.js-map-markers').forEach(function(item) {

    item.addEventListener('click', function(e){

      // find the checkbox and filter type
      let filterCheck = this.querySelector('input[type="checkbox"]');
      let filterType = filterCheck.dataset.filterType;

      if ( filterType != 'all' ) {
        checkboxes.forEach(function(item) {
          if (item != filterCheck) {
            item.checked = false;
          }
          else {
            item.checked = true;
          }
        });

        for ( let filter in _self.options.mapData.filters) {
          if ( _self.options.mapData.filters[filter].name == filterType ) {
            _self.options.mapData.filters[filter].markers.forEach(function(marker) {
              marker.setMap(_self.options.map);
              marker.setAnimation(_self.options.mapData.settings.markerAnimation ? _self.options.mapData.settings.markerAnimationType == 'DROP' ? google.maps.Animation.DROP : google.maps.Animation.BOUNCE : false);
            });
          }
          else {
            _self.options.mapData.filters[filter].markers.forEach(function(marker) {
              marker.setMap(null);
            });
          }
        }
      }
      else {
        checkboxes.forEach(function(item) {
          item.checked = true;
        });

        for ( let filter in _self.options.mapData.filters) {
          _self.options.mapData.filters[filter].markers.forEach(function(marker) {
            marker.setMap(_self.options.map);
            marker.setAnimation(_self.options.mapData.settings.markerAnimation ? _self.options.mapData.settings.markerAnimationType == 'DROP' ? google.maps.Animation.DROP : google.maps.Animation.BOUNCE : false);
          });
        }
      }

    });


  });

}


/**
 *
 *  @function createMarkers
 *  
 *  @param {}
 *  
 *  @description Creates Map Markers
 *
 */
AvvioCustomMap.prototype.createMarkers = function() {
  //console.log('%c[ Creating Avvio Custom Map Markers ]', 'background-color: #4307c3; color: #ffffff; padding: 8px 10px; border-radius: 5px; margin: 15px 0; font-weight: bold;');

  let _self = this;

  // loop through mapdata markers(if not false)
  if( _self.options.mapData.markers != false ) {

    _self.options.mapData.markers.forEach(function(data) {

      // create marker
      const marker =  new google.maps.Marker({
        position: new google.maps.LatLng(data.lat, data.long),
        icon: _self.options.mapData.filters[data.type.toLowerCase()].markerIcon,
        title: data.title ? data.title : '',
        animation: _self.options.mapData.settings.markerAnimation ? _self.options.mapData.settings.markerAnimationType == 'DROP' ? google.maps.Animation.DROP : google.maps.Animation.BOUNCE : false,
        map: _self.options.map
      });

      _self.options.allMarkers.push(marker);

      // attach click event to show infowindow (if infowindow is enabled in global setting)
      if( _self.options.mapData.settings.enableInfoWindow == true ) {
        
        marker.addListener("click", () => {
          _self.options.mapInfoWindow.close();
          _self.options.mapInfoWindow.setContent(`<div class="marker">
                            <div class="marker-card">
                                ${ data.info_image.sizes.large ? `<div class="marker-card__thumbnail" style="background-image: url(${ data.info_image.sizes.large })">` : '' }
                                </div>
                                <div class="marker-card__content">
                                    ${ data.title ? `<h3 class="marker-card__title">${ data.title }</h3>` : '' }
                                    ${ data.desc ? `<strong class="marker-card__location">${ data.desc } <i class="fas fa-map-marker-alt"></i></strong>` : '' }
                                    ${ data.cta_link.url ? `<a class="marker-card__link" href="${ data.cta_link.url }" target="${ data.cta_link.target }">${ data.cta_link.title }</a>` : '' }
                                </div>
                            </div>
                        </div>`);
          _self.options.mapInfoWindow.open(marker.getMap(), marker);
        });

      }


      // push reference to filter marker group array
      _self.options.mapData.filters[data.type.toLowerCase()].markers.push(marker);

    });

    _self.clusterNumber();

  }

}

/**
 *
 *  @function clusterNumber
 *  
 *  @param {}
 *  
 *  @description Creates Map Cluster Numbers
 *
 */
AvvioCustomMap.prototype.clusterNumber = function() {
  let _self = this;
  let NewMarkers = _self.options.allMarkers;
  let clusterIcon = _self.clusterMap.dataset.directory + '/assets/img/cluster-marker-icon.svg';
  let clusterStyles = [
    {
      textColor: 'white',
      fontFamily:"'Open Sans', Arial",
      fontWeight: '400',
      textSize: '14',
      textLineHeight: '44',
      url: clusterIcon,
      height: 44,
      width: 44
    }
  ];
  new MarkerClusterer(_self.options.map, NewMarkers, {
    gridSize: 44,
    cssClass: 'cluster',
    styles: clusterStyles,
    minimumClusterSize: 2,
    calculator: function(clusterMarker, numStyles) {
      if (clusterMarker.length >= 50) return { text: clusterMarker.length, index: 3} // red
      if (clusterMarker.length >= 5) return { text: clusterMarker.length, index: 2}  // yellow
      return { text: clusterMarker.length, index: 0}    }                      // blue
  });
}


/**
 * 
 *  Call the custom map after window is loaded. Get Map Data from the Custom Map Block and initialize Custom Map Block
 * 
*/ 
function loadCustomMap() {
  //console.log('page is fully loaded');

  // get all custom map blocks in the page
  let customMaps = document.querySelectorAll('.js-avvio-custom-map');

  if(customMaps.length > 0) {

    //console.log('%ccustomMaps: ', 'color: green', customMaps);

    // loop through the blocks
    customMaps.forEach(function(map) {

      let mainSection = map,
      mapFilters = mainSection.querySelector('.js-avvio-custom-map-filters'),
      mapContainer = mainSection.querySelector('.js-avvio-custom-map-container');

      let mapdataStrData = map.dataset.mapdata,
      mapdataStr = mapdataStrData.replace(/'/g, "\\'"), 
      mapdataArr = JSON.parse(mapdataStr),
      avvioCustomMapData = undefined;

      if (JSON.stringify(mapdataArr) !== '{}') {

        // create map instance options
        avvioCustomMapData = {
          mainSection: mainSection,
          mapFilters: mapFilters,
          mapContainer: mapContainer,
          mapData: {
            settings: {
              zoom: parseInt(mapdataArr.zoom),
              enableInfoWindow: mapdataArr.enableInfoWindow,
              markerAnimation: mapdataArr.markerAnimation,
              markerAnimationType: mapdataArr.markerAnimationType, // DROP / BOUNCE
              styled: mapdataArr.styled,
              styles: [
                {
                  "featureType": "administrative.land_parcel",
                  "elementType": "labels",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "administrative.neighborhood",
                  "elementType": "labels",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "landscape",
                  "elementType": "labels",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "landscape.man_made",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#ffffff"
                    }
                  ]
                },
                {
                  "featureType": "landscape.natural",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#ffffff"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "labels.text",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "poi.business",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "stylers": [
                    {
                      "color": "#e5fcde"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e5ffe7"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "labels.text",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "road",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#ededed"
                    }
                  ]
                },
                {
                  "featureType": "road.arterial",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#d1d1d1"
                    },
                    {
                      "weight": 1.5
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#d1d1d1"
                    },
                    {
                      "weight": 1.5
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "labels",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "road.local",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e3e3e3"
                    },
                    {
                      "weight": 0.5
                    }
                  ]
                },
                {
                  "featureType": "road.local",
                  "elementType": "labels",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "transit",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#deeefc"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "labels",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                }
              ],
            },
            mainMap: mapdataArr.mainMap,
            filters: mapdataArr.filters,
            markers: mapdataArr.markers
          }
        }

      }
      // END if

      //console.log('%c Custom Map Data', 'background-color: red; color: white', avvioCustomMapData);

      // call custom map
      var isAvvioCustomMap = new AvvioCustomMap(avvioCustomMapData);

    });
    // END loop
    
  }

};


/**
 * Initialize the script when the block is previewed within the editor
 * https://www.advancedcustomfields.com/resources/javascript-api/
 */
if (window.acf) 
{
  
    window.acf.addAction('render_block_preview/type=avvio-custom-map', setTimeout(() => { loadCustomMap }, 2000));
  
}
else if (typeof(document.querySelector(".js-avvio-custom-map")) != 'undefined' && document.querySelector(".js-avvio-custom-map") != null) {
  document.addEventListener("DOMContentLoaded", loadCustomMap);
} 